module.exports = __webpack_public_path__ + "ad.no2.7a9b785a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/ad.no2.jpg
// module id = V1I4
// module chunks = 0